import styled, { css } from 'styled-components';

import { rem } from '../../utils';
import { SwitchProps } from '../Switch';

export const StyledWrapper = styled.label<{ size: SwitchProps['size'] }>`
  display: flex;
  align-items: center;
  cursor: pointer;
  ${({ theme, size }) => css`
    width: ${rem(theme.Form.Switch.Size[size].width)};
    height: ${rem(theme.Form.Switch.Size[size].height)};
  `}
`;

export const StyledSwitch = styled.div<{
  size: SwitchProps['size'];
  $disabled: SwitchProps['disabled'];
}>`
  position: relative;

  ${({ theme, size, $disabled }) => css`
    width: ${rem(theme.Form.Switch.Size[size].width)};
    height: ${rem(theme.Form.Switch.Size[size].height)};
    background: ${theme.Color.Neutrals.Border};
    border-radius: ${rem(theme.Form.Switch.Size[size].width)};
    padding: ${rem(theme.Form.Switch.Size[size].trackPadding)};
    transition: all ${theme.Transition.Timing.Out};
    opacity: ${$disabled ? theme.Form.Switch.Opacity.Disabled : 1};
    pointer-events: ${$disabled ? 'none' : 'auto'};
  `}

  &:before {
    content: '';
    position: absolute;
    border-radius: 50%;
    top: 50%;
    transform: translate(0, -50%);
    filter: drop-shadow(0px 1px 1px rgba(0, 0, 0, 0.16));

    ${({ theme, size }) => css`
      transition: all ${theme.Transition.Timing.In};
      width: ${rem(theme.Form.Switch.Size[size].handleSize)};
      height: ${rem(theme.Form.Switch.Size[size].handleSize)};
      left: ${rem(theme.Form.Switch.Size[size].trackPadding)};
      background: ${theme.Color.NeutralsFixed.Paper};
    `}
  }
`;

export const StyledInput = styled.input<{ inputSize: SwitchProps['size'] }>`
  opacity: 0;
  position: absolute;

  ${({ theme, inputSize }) => css`
    &:checked + ${StyledSwitch} {
      background: ${theme.Color.System.Primary};

      &:before {
        transform: translate(${rem(theme.Form.Switch.Size[inputSize].transitionDistance)}, -50%);
      }
    }
  `}
`;
